export const CLOCKIN_LINETYPE_OPTIONS = [
  { Value: 'J', DisplayValue: 'J - Job' },
  { Value: 'S', DisplayValue: 'S - SM WorkOrder' },
];
